import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=8effa8c2&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=ts&"
export * from "./Search.vue?vue&type=script&lang=ts&"
import style0 from "./Search.vue?vue&type=style&index=0&id=8effa8c2&lang=scss&scoped=true&"
import style1 from "./Search.vue?vue&type=style&index=1&id=8effa8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8effa8c2",
  null
  
)

export default component.exports